/**
 * @file color-palette-service.ts
 * @description Automatically extracts a color palette from the current image.
 */

import { layers, g } from '@hcie/core';
import { EventBus } from '@hcie/shared';

export function initColorPaletteService() {
    EventBus.on('RENDER_LAYERS', () => {
        // We could debounce this if performance becomes an issue
        extractPalette();
    });
}

function extractPalette() {
    const activeLayer = layers[g.activeLayerIndex];
    if (!activeLayer || !activeLayer.ctx) return;

    const ctx = activeLayer.ctx as CanvasRenderingContext2D;
    const w = Math.min(activeLayer.canvas.width, 100); // Sample smaller area for speed
    const h = Math.min(activeLayer.canvas.height, 100);
    
    const data = ctx.getImageData(0, 0, w, h).data;
    const colorCount: Record<string, number> = {};

    for (let i = 0; i < data.length; i += 16) { // Sample every 4th pixel
        if (data[i + 3] < 128) continue; // Skip transparent
        const hex = rgbToHex(data[i], data[i+1], data[i+2]);
        colorCount[hex] = (colorCount[hex] || 0) + 1;
    }

    const sorted = Object.entries(colorCount)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 12)
        .map(e => e[0]);

    EventBus.emit('PALETTE_UPDATED', { colors: sorted });
}

function rgbToHex(r: number, g: number, b: number): string {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}
